import React, { useState } from "react";
import { Button } from "../../../components/Buttons";
import { H3, Label } from "../../../components/Text";
import { toast } from "react-toastify";
import { requestAuth } from "../../../components/services/RequestService";
import Circle from "../../../components/Animation/Circle";

export const UploadDocuments = ({ item, onClose, onReload }) => {
  console.log("🚀 ~ UploadDocuments ~ item:", item);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(() => {
    try {
      return item.data ? JSON.parse(item.data) : { files: [], desc: "" };
    } catch (e) {
      return { files: [], desc: "" };
    }
  });

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    let formData = new FormData();
    formData.append("Name", file.name);
    formData.append("File", file);
    formData.append("originalName", file.name);
    formData.append("Status", "verified");

    try {
      const res = await requestAuth("post", "/files", formData);
      const newFile = {
        name: file.name,
        url: res.data.url,
        desc: "",
      };

      const newData = {
        ...data,
        files: [...data.files, newFile],
      };
      setData(newData);
      toast.success("Archivo subido correctamente");
    } catch (error) {
      toast.error("Error al subir archivo");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (index) => {
    const newFiles = data.files.filter((_, i) => i !== index);
    setData({ ...data, files: newFiles });
    toast.info("Archivo quitado de la lista (recuerde guardar)");
  };

  const handleUpdateFile = (index, key, value) => {
    const newFiles = [...data.files];
    newFiles[index][key] = value;
    setData({ ...data, files: newFiles });
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const payload = {
        DropdownListLabel: "providers",
        btnSecondary: false,
        data: JSON.stringify(data),
        name: item.name,
        type: "Simple",
      };
      await requestAuth("put", `/Dropdown/Option/${item.id}`, payload);
      toast.success("Documentos actualizados correctamente");
      onReload();
      onClose();
    } catch (error) {
      toast.error("Error al guardar los documentos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-[80vw] p-4 flex flex-col gap-4 bg-white rounded-lg">
      <H3 className="text-blue-700">Gestión de Documentos: {item.name}</H3>

      <div className="border-2 border-dashed border-gray-300 p-6 rounded-lg flex flex-col items-center gap-2">
        {loading ? (
          <Circle />
        ) : (
          <>
            <input
              type="file"
              id="file-upload-provider"
              className="hidden"
              onChange={handleUpload}
            />
            <label
              htmlFor="file-upload-provider"
              className="cursor-pointer bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors flex items-center gap-2"
            >
              <i className="fas fa-cloud-upload-alt"></i> Subir nuevo documento
            </label>
            <span className="text-xs text-gray-400">
              PDF, Imágenes (máx 10MB)
            </span>
          </>
        )}
      </div>

      <div className="max-h-[400px] overflow-y-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-gray-600 uppercase text-[11px] font-bold">
            <tr>
              <th className="px-3 py-2 text-left">Nombre del Documento</th>
              <th className="px-3 py-2 text-left w-40">Descripción</th>
              <th className="px-3 py-2 text-center w-24">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.files.length === 0 && (
              <tr>
                <td
                  colSpan="3"
                  className="text-center py-8 text-gray-400 italic"
                >
                  No hay documentos adjuntos
                </td>
              </tr>
            )}
            {data.files.map((file, idx) => (
              <tr key={idx} className="hover:bg-gray-50 transition-colors">
                <td className="px-3 py-2">
                  <input
                    type="text"
                    className="w-full p-1 border rounded focus:ring-1 focus:ring-blue-300 outline-none"
                    value={file.name}
                    onChange={(e) =>
                      handleUpdateFile(idx, "name", e.target.value)
                    }
                  />
                </td>
                <td className="px-3 py-2">
                  <input
                    type="text"
                    className="w-full p-1 border rounded focus:ring-1 focus:ring-blue-300 outline-none"
                    value={file.desc}
                    onChange={(e) =>
                      handleUpdateFile(idx, "desc", e.target.value)
                    }
                  />
                </td>
                <td className="px-3 py-2 flex justify-center gap-3">
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 hover:text-blue-700"
                    title="Ver archivo"
                  >
                    <i className="fas fa-eye"></i>
                  </a>
                  <button
                    onClick={() => handleDelete(idx)}
                    className="text-red-500 hover:text-red-700"
                    title="Eliminar"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end gap-3 border-t pt-4">
        <button
          onClick={onClose}
          className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium"
        >
          Cancelar
        </button>
        <Button onClick={handleSave} disabled={loading}>
          {loading ? "Guardando..." : "Guardar Cambios"}
        </Button>
      </div>
    </div>
  );
};
